import { render, staticRenderFns } from "./IdentityRoleCard.vue?vue&type=template&id=e1bf7200&scoped=true&"
import script from "./IdentityRoleCard.vue?vue&type=script&lang=js&"
export * from "./IdentityRoleCard.vue?vue&type=script&lang=js&"
import style0 from "./IdentityRoleCard.vue?vue&type=style&index=0&id=e1bf7200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bf7200",
  null
  
)

export default component.exports